export default __webpack_public_path__ + "static/media/ar_2008_image.f6a1c172.png";